// extracted by mini-css-extract-plugin
export var blue = "_46-g";
export var brand = "_46-c";
export var darkGrey = "_46-f";
export var disabled = "_46-5";
export var disabledSubtle = "_46-6";
export var error = "_46-7";
export var green = "_46-h";
export var grey = "_46-e";
export var icon = "_46-0";
export var inherit = "_46-b";
export var lightGrey = "_46-d";
export var orange = "_46-j";
export var pink = "_46-l";
export var primary = "_46-1";
export var purple = "_46-m";
export var quaternary = "_46-4";
export var red = "_46-k";
export var secondary = "_46-2";
export var success = "_46-a";
export var tertiary = "_46-3";
export var warning = "_46-8";
export var warningSecondary = "_46-9";
export var white = "_46-n";
export var yellow = "_46-i";